import React from 'react'
import styles from './boost-icon.module.scss'
import cn from 'classnames'
import TreechatNoBackground from 'assets/treechat-no-background.png'

export default function PurpleBoostIcon({ contextStyles }) {
    return (
        <img
            src={TreechatNoBackground}
            className={cn(styles.boostIconComp, contextStyles)}
            alt=""
        />
    )
}
